<template>
  <div class="page-wrapper">
    <search-list @findData="findData" ></search-list>
    <div class="">
      <table-list :columns="columns" :data="data" :defaultColumns="defaultColumns"
                  :loading="loading" :total="total" :current="current"
                  :hasSave="true"
                  :cacheKey="'contractCacheColumn'"
                  @change-page="changePage">
        <Button type="primary" @click="exportContract" :loading = "btnLoading" v-p="{api:'enterprisecontract/exportContractList'}">导出合同</Button>
      </table-list>
      <delivery-input-busin :n="deliveryInputN" :parentContractFid="parentContractFid"
                            :stockFid="stockFid" :projectName="projectName"
                            @done="getpageList"
      ></delivery-input-busin>
      <delivery-input-person :n="deliveryInputPersonN" :contractId="contractId"
                             :stockFid="stockFid" :projectName="projectName"
                             :stockNumber="stockNumber" :channelType="channelType"
                             @done="getpageList"
      ></delivery-input-person>
      <release-person :n="releasePersonN" :contractFid="contractFid"
                      :stockFid="stockFid" @done="getpageList"
      ></release-person>
      <release-apply :n="releaseApplyN" :contractFid="[contractFid]" @done="getpageList"></release-apply>
      <select-room :n="selectRoomN" :contractFid="contractFid" @done="getpageList" :parentContractFid="parentContractFid"></select-room>
      <release-apply-view :n="releaseAppVN" :contractFid="contractFid" @closedone="getpageList"></release-apply-view>
      <send-sign :n="sendSignN" :stockFid="stockFid" :contractCode="contractCode"
                 :contractFid="contractFid" :stockNumber="stockNumber" :item="item"
      ></send-sign>
      <select-room-busin :n="srbN" :contractFid="contractFid" :projectFid="projectFid"
                         :parentContractFid="parentContractFid" :conEndDate="conEndDate"
                         @done="getpageList"
      ></select-room-busin>
    </div>
    <update-spart-part :n="UpdateSpartN" :contractFid="contractFid"></update-spart-part>
    <delivery-update
      :n="deliveryUpdatePersonN"
      :contractId="contractId"
      :stockFid="stockFid"
      @done="getpageList"
      :projectName="projectName"
      :stockNumber="stockNumber"
    ></delivery-update>
  </div>
</template>

<script>
  import DeliveryUpdate from './components/DeliveryUpdate'
  import SearchList from './components/SearchList'
  import TableList from "components/FilterTableList/index";
  import DeliveryInputBusin from './components/DeliveryInputBusin'
  import DeliveryInputPerson from './components/DeliveryInputPerson'
  import ReleasePerson from './components/ReleasePerson'
  import ReleaseApply from './components/ReleaseApply'
  import SelectRoom from './components/SelectRoom'
  import ReleaseApplyView from './components/ReleaseApplyView'
  import SendSign from './components/SendSign'
  // import BusinContinue from './components/CreateBusinessContract'
  import {formatMoney} from "../../../utils/format";

  import SelectRoomBusin from './components/SelectRoomBusin'
  import {list, closeContract, invalidContract, exportContractList,checkContractCount} from "../../../api/contractList";
  import {deepClone} from "../../../utils/format";
  import UpdateSpartPart from './components/UpdateSpartPart'
  import {formatDateTime} from "../../../utils/format";
  import {confirmContractForEps} from "api/contractList";
  import {checkBeforeSurrender, roomCanRenew,contractBtn} from "api/contractList";


  export default {
    name: "contractlist", //不缓存
    components: {
      SelectRoom,
      SearchList,
      TableList,
      DeliveryInputBusin,
      DeliveryInputPerson,
      ReleasePerson,
      ReleaseApply,
      ReleaseApplyView,
      SendSign,
      // BusinContinue,
      SelectRoomBusin,
      UpdateSpartPart,
      DeliveryUpdate
    },
    data() {
      return {
        btnLoading:false,
        projectName: '',
        item: {},
        deliveryUpdatePersonN: 0,
        contractId: '',
        UpdateSpartN: 0,
        conEndDate: '',
        parentContractFid: '',
        projectFid: '',
        srbN: 0,
        stockNumber: '',
        contractCode: '',
        stockFid: '',
        contractFid: '',
        channelType: false,
        searchData: {
          "contractAuditStatus": '',
          "contractDelivery": '',
          "contractSignType": '',
          "contractSource": "",
          "contractState": "",
          "cusPhoneNumber": "",
          "customerType": "",
          "expireEndDate": "",
          "expireStartDate": "",
          "leaseTime": "",
          "projectFid": "",
          "houseTypeFid": '',
          "releaseEndDate": "",
          "releaseStartDate": "",
          "signEndDate": "",
          "signStartDate": "",
          "stockRentType": "",
          "payState": "",
          isRenew: '',
          limit: 10,
          page: 1,
        },
        // businContinueN:0,
        sendSignN: 0,
        releaseAppVN: 0,
        selectRoomN: 0,
        releaseApplyN: 0,
        releasePersonN: 0,
        deliveryInputPersonN: 0,
        deliveryInputN: 0,
        current: 1,
        total: 0,
        defaultColumns: ['action', 'projectName', 'stockNumber', 'rentTypeName', 'contractStateName', 'stockRentName', 'userPhone', 'conEndDate',
          'customerName', 'conStartDate', 'contractCode', 'parentContractCode','payStateName', 'houseTypeName', 'conPeriod'],
        columns: [
          //默认项
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title: "项目",
            key: "projectName",
            align: "center",
            width:160
          },
          {
            title: "合同编号",
            key: "contractCode",
            align: "center",
            width:180,
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    if (!params.row['parentContractFid']) {
                      this.$router.push({
                        name: 'personalcontractdetail',
                        query: {id: params.row['fid'], code: params.row['contractCode']}
                      })
                    }
                    else {
                      const query = {
                        isParent: 0,
                        id: params.row['fid'],
                        code: params.row['contractCode'],
                        pid: params.row['parentContractFid'],
                      };
                      this.$router.push({name: 'companycontractdetail', query: query})  //
                    }
                  }
                }
              }, params.row['contractCode'])
            }
          },
          {
            title: "主合同编号",
            key: "parentContractCode",
            align: "center",
            width:180,
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    const query = {
                      isParent: 1,
                      id: params.row['fid'],
                      code: params.row['contractCode'],
                      pid: params.row['parentContractFid'],
                    };
                    this.$router.push({
                      name: 'contractCompanycontractdetail',
                      query: query
                    })  //
                  }
                }
              }, params.row['parentContractCode'])
            }

          },
          {
            title: "房间/床位号",
            key: "stockNumber",
            align: "center",
            width:120
          },
          {
            title: "房型名称",
            key: "houseTypeName",
            align: "center",
            width:200
          },
          {
            title: "租约类型",
            key: "rentTypeName",
            align: "center",
            width:100
          },
          {
            title: "签约租期时长",
            key: "conPeriod",
            align: "center",
            width:120
          },
          {
            title: "出租类型",
            key: "stockRentName",
            align: "center",
            width:100
          },
          {
            title: "合同状态",
            key: "contractStateName",
            align: "center",
            width:100
          },
          {
            title: "支付状态",
            key: "payStateName",
            align: "center",
            width:100
          },
          {
            title: "签约客户",
            key: "customerName",
            align: "center",
            width:220
          },
          {
            title: "签约手机号",
            key: "userPhone",
            align: "center",
            width:120
          },
          {
            title: "起租日",
            key: "conStartDate",
            align: "center",
            width:120,
            render: (h, params) => {
              return h('span', {}, this.format(params.row['conStartDate'], false))
            }
          },
          {
            title: "到期日",
            key: "conEndDate",
            align: "center",
            width:120,
            render: (h, params) => {
              return h('span', {}, this.format(params.row['conEndDate'], false))
            }
          },

          //非默认项
          {
            title: "实际押金",
            key: "actualDepositPrice",
            align: "center",
            width:100,
            render:(h,params)=>{
              return h('div',{
                style:{
                  'text-align':'right'
                }
              },formatMoney(params.row['actualDepositPrice']))
            }
          },
          {
            title: "实际月租",
            key: "actualHousePrice",
            align: "center",
            width:100,
            render:(h,params)=>{
              return h('div',{
                style:{
                  'text-align':'right'
                }
              },formatMoney(params.row['actualHousePrice']))
            }
          },
          {
            title: "实际服务费",
            key: "actualServicePrice",
            align: "center",
            width:100,
            render:(h,params)=>{
              return h('div',{
                style:{
                  'text-align':'right'
                }
              },formatMoney(params.row['actualServicePrice']))
            }
          },
          {
            title: "续约状态",
            key: "isRenew",
            align: "center",
            width:100,
            render:(h,params)=>{
              return h('span',{},params.row['isRenew']===1?'已续约':'未续约')
            }
          },
          {
            title: "交割状态",
            key: "deliveryStateName",
            align: "center",
            width:100
          },
          {
            title: "签约日期",
            key: "conSignDate",
            align: "center",
            width:120,
            render: (h, params) => {
              return h('span', {}, this.format(params.row['conSignDate'], false))
            }
          },
          {
            title: "前序合同编号",
            key: "preContractCode",
            align: "center",
            width:180,
          },
          {
            title: "签约类型",
            key: "contractTypeName",
            align: "center",
            width:100
          },
          {
            title: "审核状态",
            key: "auditStateName",
            align: "center",
            width:100
          },
          {
            title: "客户类型",
            key: "subjectTypeName",
            align: "center",
            width:120
          },
          {
            title: "实际退租日",
            key: "conReleaseDate",
            align: "center",
            width:120,
            render:(h,params)=>{
              return h('span',{},this.format(params.row['conReleaseDate'],false))
            }
          },
          {
            title: "签约ZO",
            key: "handleZo",
            align: "center",
            width:100
          },
          {
            title: "审核通过时间",
            key: "contractAuditDate",
            align: "center",
            width:120,
            render:(h,params)=>{
              return h('span',{},this.format(params.row['contractAuditDate'],false))
            }
          },
          {
            title: "操作",
            width: 150,
            key: "action",
            align: "center",
            fixed:'right',
            render: (h, params) => {
              //1、当合同状态为已关闭、已失效、已到期时，不展示所有按钮  +已退租
              if (['ygb', 'ysx', 'ydq','ytz'].indexOf(params.row['contractState']) !== -1) {
                return h('div', {}, '')
              }
              const deliveryInputBusin = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'sign/delivery/save'
                    }
                  }
                ],
                on: {
                  click: () => {
                    // this.contractFid=params.row['fid']
                    this.parentContractFid = params.row['parentContractFid'];
                    this.stockFid = params.row['stockFid'];
                    this.projectName = params.row['projectName'];
                    this.deliveryInputN++
                  }
                }
              }, params.row['deliveryState'] === 2 ? '修改交割' : '录入交割');
              const close = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'contract/closeContract'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.closeContract(params.row)
                  },
                },
                style: {
                  marginRight: '15px'
                }
              }, '关闭');
              const insure = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'enterprisecontract/confirmContractForEps'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.insureContract(params.row)
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '确认合同');
              const deliveryInputPerson = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'sign/delivery/save'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.contractId = params.row['fid'];
                    this.stockFid = params.row['stockFid'];
                    this.projectName = params.row['projectName'];
                    this.stockNumber = params.row['stockNumber'];
                    this.channelType = params.row['channelType'];
                    this.deliveryInputPersonN++
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '录入交割');

              const deliveryUpdatePerson = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'sign/delivery/save'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.contractId = params.row['fid'];
                    this.stockFid = params.row['stockFid'];
                    this.projectName = params.row['projectName'];
                    this.stockNumber = params.row['stockNumber'];
                    this.deliveryUpdatePersonN++
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '修改交割');

              const releasePerson = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:['surrender/personal/submit','surrender/eps/submit']
                    }
                  }
                ],
                on: {
                  click: () => {
                    const p1 = {
                      contractCode: params.row['contractCode']
                    };
                    checkBeforeSurrender(p1).then(res => {
                      if (res.data.old) {
                        this.$Notice.warning({
                          desc: res.data.old ,
                          duration:0
                        });
                      }
                      if (res.data.kfp) {
                        this.$Notice.warning({
                          desc: res.data.kfp ,
                          duration:0
                        });
                      }
                      if (res.data.xnsk) {
                        this.$Notice.warning({
                          desc: res.data.xnsk ,
                          duration:0
                        });
                      }
                      if (res.data.whx) {
                        this.$Notice.warning({
                          desc: res.data.whx ,
                          duration:0
                        });
                      }

                    }).catch(() => {
                      return
                    });
                    this.contractFid = params.row['fid'];
                    this.stockFid=params.row['stockFid'];
                    this.releasePersonN++
                  }
                },
                style: {
                  marginRight: '15px'
                }

              }, '解约');

              const releaseBusiness = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:['surrender/personal/submit','surrender/eps/submit']
                    }
                  }
                ],
                on: {
                  click: () => {
                    const p1 = {
                      contractCode: params.row['contractCode']
                    };
                    checkBeforeSurrender(p1).then(res => {
                      if (res.data.old) {
                        this.$Notice.warning({
                          desc: res.data.old ,
                          duration:0
                        });
                      }
                      if (res.data.kfp) {
                        this.$Notice.warning({
                          desc: res.data.kfp ,
                          duration:0
                        });
                      }
                      if (res.data.xnsk) {
                        this.$Notice.warning({
                          desc: res.data.xnsk ,
                          duration:0
                        });
                      }
                      if (res.data.whx) {
                        this.$Notice.warning({
                          desc: res.data.whx ,
                          duration:0
                        });
                      }

                    }).catch(error => {
                    });
                    const id = params.row['fid'];
                    this.$router.push({name: 'releasebusiness', params: {id}})
                  }
                },
                style: {
                  marginRight: '15px'
                }

              }, '解约');
              const releaseApplyPerson = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'surrender/submitUnRentApply'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.contractFid = params.row['fid'];
                    this.releaseApplyN++
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '申请解约');

              const releaseApplyBusi = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'surrender/submitUnRentApply'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.contractFid = params.row['fid'];
                    this.parentContractFid=params.row['parentContractFid'];
                    this.selectRoomN++
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '申请解约');

              const releaseApplyView = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'surrender/checkRentApply'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.contractFid = params.row['fid'];
                    this.releaseAppVN++
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '解约申请查看');

              const contineContactPerson = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'cardsview',
                      api:'enterprisecontract/epsContract/create'
                    }
                  }
                ],
                on: {
                  click: () => {
                    const p2 = {
                      contractCode: params.row['contractCode']
                    };
                    roomCanRenew(p2).then(res => {
                      if(res.data.isNonPay === 1){
                        this.$Message.info(`合同【${params.row['contractCode']}】存在未核销账单，请及时关注！`)
                      }
                      this.stockFid = params.row['stockFid'];
                      this.contractFid = params.row['fid'];
                      this.contractCode = params.row['contractCode'];
                      this.stockNumber = params.row['stockNumber'];
                      this.item = params.row;
                      this.sendSignN++
                    })

                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '续约');

              const businContinue = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'cardsview',
                      api:'enterprisecontract/epsContract/create'
                    }
                  }
                ],
                on: {
                  click: () => {
                    const p1 = {
                      contractCode: params.row['parentContractCode']
                    };
                    roomCanRenew(p1).then(res => {
                      if(res.data.isNonPay === 1){
                        this.$Message.info(`合同【${params.row['contractCode']}】存在未核销账单，请及时关注！`)
                      }
                      this.contractFid = params.row['fid'];
                      this.projectFid = params.row['projectFid'];
                      this.parentContractFid = params.row['parentContractFid'];
                      this.conEndDate = params.row['conEndDate'];
                      this.srbN++

                    }).catch(error => {
                    })

                  },

                },
                style: {
                  marginRight: '15px'
                }
              }, '续约');

              const invalidContract = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'contract/invalidContract'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title:'作废合同',
                      content: '<p>确认作废此合同？</p>',
                      onOk:()=>{
                        this.$router.push({
                        name: 'settleInfo',
                        query: {id: params.row.fid}
                      })
                      }
                    })
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '作废');

              const updateSpart = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'enterprisecontract/updateSparePart'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.contractFid = params.row['fid'];
                    this.UpdateSpartN++
                  }
                },
                style: {
                  marginRight: '15px'
                }
              }, '修改备件');

              const firstReceipt = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'contractlist',
                      api:'bill/getEpsBillDetail'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'firstcollection',
                      query: {isFirst: 1, pCode: params.row['parentContractCode'], uid: params.row['customerUid']}
                    })
                  }
                },
              }, '首次收款');
              const actions = [];
              const data = params.row;

              //关闭：企业合同；合同状态为【待确认】
              if (data.contractState === 'dqr' || (data.subjectType === 1 && data.contractState === 'yqr' && data.payState === 0)) {
                actions.push(close)
              }
              //确认合同  客户类型为企业客户，合同状态为【待确认】，交割状态为【待确认交割】
              if (data.subjectType === 3 && data.contractState === 'dqr' && data.deliveryState === 2) {
                actions.push(insure)
              }
              //续约  续约状态为【未续约】，审核状态为【审核通过】，
              // ??且满足基础规则配置的续约天数限制
              const timelimit = (new Date().valueOf() - params.row['conEndDate'] < 86400000*2);

              if (data.isRenew === 0 && data.auditState === 2 && timelimit && (data.surApplyStatus === null || data.surApplyStatus === 1)) {
                data.subjectType === 1 && actions.push(contineContactPerson);
                data.subjectType === 3 && actions.push(businContinue)
              }
              // 录入交割  加不为续约状态的合同
              // 企业合同：交割状态为【待录入交割】或【待确认交割】
              //个人合同：交割状态为【待录入交割】
              if (data.subjectType === 1 && data.deliveryState === 0 && data.contractType !== 1) {
                actions.push(deliveryInputPerson)
              }
              if (data.subjectType === 3 && (data.deliveryState === 0 || data.deliveryState === 2) && data.contractType !== 1) {
                actions.push(deliveryInputBusin)
              }
              //个人修改交割  交割状态为【待确认交割】
              if (data.subjectType === 1 && data.deliveryState === 2 && data.contractType !== 1) {
                actions.push(deliveryUpdatePerson)
              }

              // 解约 解约申请状态为”生效“，且解约状态为”null“或”已关闭“
              if (data.surApplyStatus === 0 && (data.surStatus === null || data.surStatus === 4)) {
                data.subjectType === 1 && actions.push(releasePerson);
                data.subjectType === 3 && actions.push(releaseBusiness)
              }

              //申请解约  审核状态为【审核通过】，续约状态为【未续约】，解约申请状态为”null“或”已关闭“（不存在生效中的解约申请）
              if (data.isRenew === 0 && data.auditState === 2 && (data.surApplyStatus === null || data.surApplyStatus === 1)) {
                data.subjectType === 1 && actions.push(releaseApplyPerson);
                data.subjectType === 3 && actions.push(releaseApplyBusi)
              }
              //作废  客户类型为企业客户，合同状态为【已签约】，支付状态为【未支付】
              if (data.subjectType === 3 && data.contractState === 'yqy' && data.payState === 0) {
                actions.push(invalidContract)
              }

              //修改备件  审核状态为【审核驳回】
              if (data.auditState === 1) {
                actions.push(updateSpart)
              }

              //首次收款  客户类型为企业客户，合同状态为【已签约】，支付状态为【未支付】、【部分支付】
              if (data.subjectType === 3 && data.contractState === 'yqy' && (data.payState === 0 || data.payState === 1)) {
                actions.push(firstReceipt)
              }

              //解约申请查看：解约申请状态为”生效“，且解约状态为”null“或”已关闭“
              if (data.surApplyStatus === 0 && (data.surStatus === null || data.surStatus === 4)) {
                actions.push(releaseApplyView)
              }
              return h('div', {}, actions)
            }
          },

        ],
        data: [],
        loading: false
      }
    },
    watch:{
      $route(to, from) {
        if(from.name==='releasebusiness' || from.name==='firstcollection' || from.name === 'settleInfo'){
          this.getpageList()
        }
      }
    },
    methods: {
      exportContract(){
        const data = {};
        for (const key in this.searchData) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchData[key]
        }
        checkContractCount(data).then( res => {
          if(res.data > 10000){
            this.$Modal.info({
              title: '导出合同',
              content:'上限10000条，请选择条件后下载'
            });
          } else {
            this.btnLoading = true;
            exportContractList(data).then( res => {
              console.log(res.headers,'headers.......')
              const fileName = res.headers.filename || 'excel.xls';
              const blob = new Blob([res.data]);
              // var reader = new FileReader();
              // reader.readAsText(blob);
              // reader.onload = function(){
              // var resObj = JSON.parse(reader.result);
              // console.log(typeof resObj)
              // if(!resObj.code ){
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.style.display = 'none';
              link.href = url;
              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
              this.btnLoading = false
              // } else {
              //   this.$Message.error(resObj.message)
              // }
              // }
            }).catch( err => {
              this.btnLoading = false;
              console.log('err')
            })
          }
        })

      },
      formatMoney:formatMoney,
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)
      },
      invalidContract(item) {
        this.$Modal.confirm({
          title: '作废合同',
          content: '<p>确认作废此合同？</p>',
          onOk: () => {
            const params = {
              contractFid: item.fid,
              subjectType:item.subjectType
            };
            invalidContract(params).then(res => {
              this.$Message.success('该合同已作废');
              this.getpageList()
            }).catch(error => {
            })
          }
        })
      },
      getpageList() {
        list(this.searchData).then(res => {
          res.data && res.data.tContractVos&&(this.data = res.data.tContractVos);
          this.total = res.data.total
        })
      },
      insureContract(item) {
        this.$Modal.confirm({
          title: '确认合同',
          content: '<p>请仔细核对合同信息、客户信息、账单信息、交割信息，确认后合同将生效，且无法修改！你确认继续吗？</p>',
          onOk: () => {
            if (!item.parentContractCode) {
              this.$Message.info('该条记录没有parentContractCode字段');
              return
            }
            const params = {
              parentContractCode: item.parentContractCode
            };
            confirmContractForEps(params).then(res => {
              this.$Message.success('操作成功');
              this.getpageList()
            }).catch(error => {})

          }
        })

      },
      closeContract(item) {
        this.$Modal.confirm({
          title: '关闭合同',
          content: '<p>继续操作合同将关闭并且房间会被释放，此操作不可逆！你确认继续吗？</p>',
          onOk: () => {
            const params = {
              contractFid: item.fid,
              subjectType:item.subjectType
            };
            closeContract(params).then(res => {
              this.$Message.success('该合同已关闭');
              this.getpageList()
            }).catch(error => {})
          }
        })
      },
      findData(params) {
        this.searchData = deepClone(params);
        this.current = 1;
        this.getpageList()
      },
      changePage(n) {
        this.current = n;
        this.searchData.page = n;
        this.getpageList()
      }
    },
    created() {
      if(this.$route.params.cusPhoneNumber){
        this.searchData.cusPhoneNumber = this.$route.params.cusPhoneNumber
      }
      this.getpageList()
    }
  }
</script>

<style scoped>
  .ivu-notice{
    z-index: 100000000 !important;
  }

</style>
